export const ERROR_CODE = {
  // send message
  RECIPIENTS_LIMIT_EXCEEDED: 'RECIPIENTS_LIMIT_EXCEEDED',

  // mass send job for process applicants
  NO_RECIPIENTS: 'NO_RECIPIENTS',

  // process
  NO_CREDITS: 'NO_CREDITS', // create|reopen process
  EXISTS: 'EXISTS', // reopen process

  // process apply
  DEADLINE: 'ERROR_DEADLINE',
  NO_RESUME: 'ERROR_NO_RESUME',
  NO_RECOM: 'ERROR_NO_RECOM',
  NO_GAT: 'ERROR_NO_GAT',
  CRITERIA_MISMATCH: 'ERROR_CRITERIA_MISMATCH',
};

export default ERROR_CODE;
